import { useEffect } from "react";
import { useIsAdmin } from "../hooks/useIsAdmin";
import { setGlobalAdminStatus } from "../utils/logger";

/**
 * Provider that updates the global logger admin status
 * Must be rendered inside FirebaseProvider (requires Firebase context)
 */
export function AdminStatusProvider({ children }: { children: React.ReactNode }) {
  const isAdmin = useIsAdmin();

  useEffect(() => {
    setGlobalAdminStatus(isAdmin);
  }, [isAdmin]);

  return <>{children}</>;
}

export default AdminStatusProvider;
